import * as SettingsAction from './settings.action';
import * as SettingsSelect from './settings.select';

export { SettingsAction, SettingsSelect };
